(function () {
	'use strict';
	angular.module('app.core')
		.service('leanTableConfigService', leanTableConfigService);

	leanTableConfigService.$inject = ['$rootScope','$state', '$stateParams', '$timeout', 'leanFilterService', 'storeService',
		'navigationService', 'buyerStdCurrentShortagesService', 'localStorageService'];

	function leanTableConfigService($rootScope, $state, $stateParams, $timeout, leanFilterService, storeService,
			navigationService, buyerStdCurrentShortagesService, localStorageService) {
		var mandatoryDefaultFilters = false;
		var extraFilters;
		var defaultFilters;
		var defaultSorter;
		var unsubscribe;
		var reportSettingsId;

		return {
			getConfig: getConfig,
			setReportSettingsId: setReportSettingsId,
			setMandatoryDefaultFilters: setMandatoryDefaultFilters,
			setDefaultFilters: setDefaultFilters,
			setExtraFilters: setExtraFilters,
			setDefaultSorter: setDefaultSorter,
			setFiltersConfigFromDashboard: setFiltersConfigFromDashboard,
			translateDeliveryStatusCode: translateDeliveryStatusCode,
			getChatStatus: getChatStatus
		};

		function getConfig(columnDefinitions, reportSettingsName, reportSettingsScope, viewType, siteForReportSettings) {
			if (reportSettingsName !== globalReportName && reportSettingsId !== globalReportName) return;

			var columnSettings = convertColumnDefinitionsToSettings(columnDefinitions);

			var defaultSettings = {
				mandatoryDefaultFilters: mandatoryDefaultFilters,
				filters: defaultFilters,
				sorters: defaultSorter,
				columns: columnSettings,
				viewType: viewType
			};

			var paramSettings;
			var qParams = parseQueryString(window.location.href);

			if (qParams && qParams.drilldownSettings) {
				paramSettings = JSON.parse(decodeURIComponent(qParams.drilldownSettings));
			} else if (qParams && qParams['drilldown'] === '1') {
				paramSettings = getSettingsFromQueryParams(qParams);
			} else if ($stateParams.filters) {
				paramSettings = getSettingsFromQueryParams($stateParams.filters);
			}
			var factoryNdx = siteForReportSettings || globalConfig.factory.id;
			if (unsubscribe) {
				unsubscribe();
			}
			unsubscribe = storeService.subscribe(function () {
				var state = storeService.getState();
				if (state.previousAction.type === 'report-settings/ready'
						&& (state.reportSettings.reportName === globalReportName
							|| state.reportSettings.reportSettingsId === globalReportName)) {
					unsubscribe(); // must unsubscribe immediately
					getReportSettingsSuccess(state.reportSettings, null, paramSettings);
				} else if (state.previousAction.type === 'report-settings/fetch-error' && state.previousAction.error) {
					var appSection = $state.current.name.split('.')[1];
					var myViews = storeService.getMyViewsForAppSection(appSection);
					var viewIsInSidebar = myViews.some(function (savedView) {
						return savedView.id === state.previousAction.meta.reportSettingsId;
					});
					if (viewIsInSidebar) {
						storeService.loadMyViews(globalConfig.factory.id)
						.then(function(response) {
							if (response.data) {
								var firstView = response.data[0];
								$state.go('app.' + appSection + '.' + firstView.baseReportName, { reportId: firstView.id });
							} else {
								navigationService.goToTabFirstView(appSection);
							}
						}).catch(function(error) {
							navigationService.goToTabFirstView(appSection);
						});
						unsubscribe();
					} else {
						unsubscribe();
						$rootScope.$broadcast('reportConfigFailed');
					}
				}
			});

			if (reportSettingsId) {
				storeService.loadSavedView(factoryNdx, reportSettingsId, defaultSettings, paramSettings);
			} else {
				storeService.loadReportSettings(factoryNdx, reportSettingsName, reportSettingsScope, defaultSettings, paramSettings);
			}
		}

		function setFiltersConfigFromDashboard(providedSettings) {
			if (providedSettings.dashboardId !== globalReportName) return;
			getReportSettingsSuccess(storeService.getState().reportSettings, true);
		}

		function setMyItemFilter(settings, fromDashboard) {
			// On initial load check if the filter config has my item filter.
			// If Yes, then check if the logged in user is a valid buyer in selected sites.
			// If the user is not a valid buyer then disable the my item filter.
			var index = findInArray(settings.filters, 'id', 'myItemsOnly');
			if (index !== -1) {
				buyerStdCurrentShortagesService.isCurrentUserBuyerInSites().then(function (response) {
					if (!response) {
						leanFilterService.myItemFilter.enabled = false;
						leanFilterService.myItemFilter.selected = false;
						storeService.dispatch({
							type: storeService.actions.FILTERS_DELETE_ONE,
							payload: {
								id: 'myItemsOnly'
							},
							meta: {
								reportName: globalReportName,
								reportSettingsId: settings.reportSettingsId,
								userModified: false,
								doNotSave: true
							}
						});
					}
				});
			}
		}

		// make sure the dashboard directive is loaded before broadcasting.
		function broadcastConfigReady(fromDashboard) {
			if (!fromDashboard) {
				$rootScope.$broadcast('reportConfigReady');
			} else {
				if (jQuery('.embeddedBody.dashboard-container').length) {
					$rootScope.$broadcast('reportConfigReady');
				} else {
					$timeout(function () {
						broadcastConfigReady(fromDashboard);
					}, 10);
				}
			}
		}

		function getReportSettingsSuccess(settings, fromDashboard, paramSettings) {
			if(leanFilterService.useFactoryFilter) {
				leanFilterService.updateFactoryFilterFromStoredConfig(settings, null, true);
			} else {
				leanFilterService.updateHierarchicalFilters(true);
			}
			$timeout(function () {
				// Pass in the updated store settings. To make sure if the settings is updated from
				// updateFactoryFilterFromStoredConfig/updateHierarchicalFilters method.
				setMyItemFilter(storeService.getState().reportSettings, fromDashboard);
				leanFilterService.updateFiltersFromStoredConfig(storeService.getState().reportSettings, true, paramSettings !== undefined);
				broadcastConfigReady(fromDashboard);
			}, 0);

		}

		function setMandatoryDefaultFilters(val) {
			mandatoryDefaultFilters = val;
		}

		function setDefaultFilters(filters) {
			defaultFilters = filters;
		}

		function setExtraFilters(filters) {
			extraFilters = filters;
		}

		function setDefaultSorter(property, direction) {
			defaultSorter = [];
			if (property && direction) {
				defaultSorter = [{ property: property, direction: direction }];
			}
		}

		function setReportSettingsId(id) {
			reportSettingsId = id;
		}

		function convertColumnDefinitionsToSettings(columnDefinitions) {
			if(!columnDefinitions) return [];
			var resolutionVal = getResolutionVal();
			var columnSettings = [];
			for (var i = 0; i < columnDefinitions.length; i++) {
				var column = {};
				column.name = columnDefinitions[i].id;
				column.show = columnDefinitions[i].show == null ? false: columnDefinitions[i].show;
				column.order = columnDefinitions[i].order || 0;
				column.width = {};
				column.width[resolutionVal] = columnDefinitions[i].width;
				column.grouped = columnDefinitions[i].grouped || false;
				column.pinnedLeft = columnDefinitions[i].pinnedLeft || false;
				column.pinnedRight = columnDefinitions[i].pinnedRight || false;
				column.pinnedPosition = columnDefinitions[i].pinnedPosition;
				columnSettings.push(column);
			}
			return columnSettings;
		}

		function getFilterQueryParamValues(filtersArrayString) {
			filtersArrayString = filtersArrayString.replaceAll('\'', '\"');
			return JSON.parse(filtersArrayString);
		}

		function translateDeliveryStatusCode(selectedValues) {
			if (!selectedValues) {
				return [];
			}
			var statuses = [{
				deliveryStatusId: 'Early',
				deliveryStatus: 'Delivered - Early'
			}, {
				deliveryStatusId: 'Late',
				deliveryStatus: 'Delivered - Late'
			}, {
				deliveryStatusId: 'OnTime',
				deliveryStatus: 'Delivered - On-time'
			}, {
				deliveryStatusId: 'NotDeliveredYetPastDue',
				deliveryStatus: 'Open - Behind Schedule'
			}, {
				deliveryStatusId: 'NotDeliveredYet',
				deliveryStatus: 'Open'
			}];
			return statuses.filter(function(status) {
				return selectedValues.indexOf(status.deliveryStatusId) != -1 || selectedValues.indexOf(status.deliveryStatus) != -1;
			}).map(function(status) {
				return status.deliveryStatus;
			});

		}

		function getSettingsFromQueryParams(qParams) {

			function setMyItemFilterValue(filterId, value) {
				if (value && value === globalConfig.user.firstName + ' ' + globalConfig.user.lastName) {
					paramSettings.filters.push({
						'id': filterId,
						'value': 'true'
					});
				}
			}

			function setFilterValue(filterId, values, unselectedValues) {
				if (values && values.length > 0 ||
					unselectedValues && unselectedValues.length) {
					var index = findInArray(paramSettings.filters, 'id', filterId);
					if (index >= 0) {
						paramSettings.filters[index].values = values;
						paramSettings.filters[index].unselectedValues = unselectedValues;
					} else {
						paramSettings.filters.push({
							'id': filterId,
							'values': values,
							'unselectedValues': unselectedValues
						});
					}
				}
			}

			function setStringFilterValue(filterId, value) {
				if (value && value != '') {
					var index = findInArray(paramSettings.filters, 'id', filterId);
					if (index >= 0) {
						paramSettings.filters[index].value = value;
					} else {
						paramSettings.filters.push({
							'id': filterId,
							'value': value
						});
					}
				}
			}

			function setRangeFilterValue(filterId, valueOne, valueTwo, comparatorAbbr, value) {
				if (valueOne || valueTwo || value || valueOne === 0) {
					var comparatorNames = {
						lt: 'Less Than',
						lte: 'Less Than Or Equal To',
						eq: 'Equal To',
						noteq: 'Not Equal To',
						gt: 'Greater Than',
						gte: 'Greater Than or Equal To',
						btw: 'Between',
						notbtw: 'Not Between'
					};

					var index = findInArray(paramSettings.filters, 'id', filterId);
					if (index >= 0) {
						paramSettings.filters[index].valueOne = valueOne;
						if (valueTwo) {
							paramSettings.filters[index].valueTwo = valueTwo;
						}
						if (value) {
							paramSettings.filters[index].value = value;
						}
						paramSettings.filters[index].comparator = comparatorNames[comparatorAbbr];
					} else {
						paramSettings.filters.push({
							'id': filterId,
							'comparator': comparatorNames[comparatorAbbr],
							'valueOne': valueOne,
							'valueTwo': valueTwo,
							'value': value
						});
					}
				}
			}

			function setDateFilterValue(filterId, valueOne, valueTwo, comparatorAbbr) {
				if (valueOne && comparatorAbbr && !isNaN(valueOne)) {
					valueOne = parseInt(valueOne);
					if (valueTwo && !isNaN(valueTwo)) {
						valueTwo = parseInt(valueTwo);
					}
					setRangeFilterValue(filterId, valueOne, valueTwo, comparatorAbbr);
				}
			}

			leanFilterService.setSearchBoxDataValue('');
			var paramSettings = {};
			var i;

			// Get the default filters
			paramSettings.filters = defaultFilters ? defaultFilters : [];

			// Override with any incoming query params
			var buyerCodeList = qParamToList(qParams['buyerCode']);
			setFilterValue('buyerCode', buyerCodeList);

			var plannersList = qParamToList(qParams['planners']);
			var notPlannersList = qParamToList(qParams['notPlanners']);
			if (plannersList && plannersList.length > 0) {
				setFilterValue('planners', plannersList);
				setFilterValue('planner', plannersList);
			} else if (notPlannersList && notPlannersList.length > 0) {
				setFilterValue('planners', undefined, notPlannersList);
				setFilterValue('planner', undefined, notPlannersList);
			}

			var plannerList = qParamToList(qParams['planner']);
			var notPlannerList = qParamToList(qParams['notPlanner']);
			if (plannerList && plannerList.length > 0) {
				setFilterValue('planners', plannerList);
				setFilterValue('planner', plannerList);
			} else if (notPlannerList && notPlannerList.length > 0) {
				setFilterValue('planners', undefined, notPlannerList);
				setFilterValue('planner', undefined, notPlannerList);
			}

			var orderNumber = qParams['orderNumber'];
			setStringFilterValue('orderNumber', orderNumber);

			var supplyOrderNumber = qParams['supplyOrderNumber'];
			if (supplyOrderNumber && supplyOrderNumber !== '') {
				setStringFilterValue('supplyOrderNumber', decodeURIComponent(supplyOrderNumber));
			}

			var metricList = qParamToList(qParams['metricNdx']);
			setFilterValue('metric', metricList);

			var itemGroupNdxList = qParamToList(qParams['itemGroupNdx']);
			var notItemGroupNdxList = qParamToList(qParams['notItemGroupNdx']);
			// convert itemGroupNdx's from strings to integers if not LDNA_A_S
			if (qParams['itemGroupNdx'] !== 'LDNA_A_S') {
				for (i = 0; i < itemGroupNdxList.length; i++) {
					itemGroupNdxList[i] = isNaN(itemGroupNdxList[i]) ? itemGroupNdxList[i] : Number(itemGroupNdxList[i]);
				}
			}
			if (qParams['notItemGroupNdx'] !== 'LDNA_A_S') {
				for (i = 0; i < notItemGroupNdxList.length; i++) {
					notItemGroupNdxList[i] = isNaN(notItemGroupNdxList[i]) ? notItemGroupNdxList[i] : Number(notItemGroupNdxList[i]);
				}
			}

			if (qParams['itemGroupNdx'] == 'LDNA_A_S' || qParams['notItemGroupNdx'] == 'LDNA_A_S') {
				setFilterValue('itemGroupNdx', ['LDNA_A_S']);
			} else if (itemGroupNdxList && itemGroupNdxList.length > 0) {
				setFilterValue('itemGroupNdx', itemGroupNdxList, undefined);
			} else if (notItemGroupNdxList && notItemGroupNdxList.length > 0) {
				setFilterValue('itemGroupNdx', undefined, notItemGroupNdxList);
			}

			var spendType = qParamToList(qParams['spendType']);
			setFilterValue('spendType', spendType);

			var supplierList = qParamToList(qParams['supplier']);
			setFilterValue('supplierNdx', supplierList);

			var itemGroupNameList = qParamToList(qParams['itemGroupName']);
			setFilterValue('itemGroupNdx', itemGroupNameList);

			var erpOrderPolicyList = qParamToList(qParams['erpOrderPolicy']);
			setFilterValue('erpOrderPolicy', erpOrderPolicyList);

			var orderPolicyList = qParamToList(qParams['orderPolicy']);
			setFilterValue('orderPolicy', orderPolicyList);

			var startMonthList = qParamToList(qParams['startMonth']);
			setFilterValue('startMonth', startMonthList);

			var deliveryStatusList = qParamToList(qParams['deliveryStatus']);
			setFilterValue('deliveryStatus', translateDeliveryStatusCode(deliveryStatusList));

			var poPriceList = qParamToList(qParams['poPrice']);
			setFilterValue('poPrice', poPriceList);

			var state = qParamToList(qParams['state']);
			setFilterValue('state', state);

			var materialGroupList = qParamToList(qParams['materialGroup']);
			var notMaterialGroupList = qParamToList(qParams['notMaterialGroup']);

			if (materialGroupList && materialGroupList.length > 0) {
				setFilterValue('materialGroup', materialGroupList);
			} else if (notMaterialGroupList && notMaterialGroupList.length > 0) {
				setFilterValue('materialGroup', undefined, notMaterialGroupList);
			}

			var materialTypeList = qParamToList(qParams['materialType']);
			setFilterValue('materialType', materialTypeList);

			var entityList = qParamToList(qParams['entity']);
			setFilterValue('entity', entityList);

			var customerIdsList = qParamToList(qParams['customerId']);
			setFilterValue('customerId', customerIdsList);

			var customerSuccessEntitiesList = qParamToList(qParams['entityId']);
			setFilterValue('entityId', customerSuccessEntitiesList);

			var divisionList = qParamToList(qParams['division']);
			setFilterValue('division', divisionList);

			var businessUnitList = qParamToList(qParams['businessunit']);
			setFilterValue('businessunit', businessUnitList);

			var factoryList = qParamToList(qParams['factory']);
			setFilterValue('factory', factoryList);

			var taskStatusList = qParamToList(qParams['taskStatus']);
			setFilterValue('taskStatus', taskStatusList);

			var taskCategoryList = qParamToList(qParams['taskCategory']);
			setFilterValue('taskCategory', taskCategoryList);

			var projectAreaList = qParamToList(qParams['projectArea']);
			setFilterValue('projectArea', projectAreaList);

			var projectStageList = qParamToList(qParams['projectStageId']);
			setFilterValue('projectStageId', projectStageList);

			var projectStageIdList = qParamToList(qParams['stageId']);
			setFilterValue('stageId', projectStageIdList);

			var projectStageIdNoStaticList = qParamToList(qParams['stageIdNoStatic']);
			setFilterValue('stageIdNoStatic', projectStageIdNoStaticList);

			var projectCategoryList = qParamToList(qParams['projectCategoryId']);
			setFilterValue('projectCategoryId', projectCategoryList);

			var projectTypeList = qParamToList(qParams['projectType']);
			setFilterValue('projectType', projectTypeList);

			var projectManagerList = qParamToList(qParams['projectManagerId']);
			setFilterValue('projectManagerId', projectManagerList);

			var projectMemeberList = qParamToList(qParams['projectInvolvedId']);
			setFilterValue('projectMemberId', projectMemeberList);

			var goalList = qParamToList(qParams['projectGoalId']);
			setFilterValue('projectGoalId', goalList);

			var projectSavingsList = qParamToList(qParams['projectSavings']);
			setFilterValue('projectSavings', projectSavingsList);

			var projectSavingsCateoryList = qParamToList(qParams['projectSavingsCategoryId']);
			setFilterValue('projectSavingsCategoryId', projectSavingsCateoryList);

			var responsibleUserList = qParamToList(qParams['responsibleId']);
			var responsibleUserList1 = qParamToList(qParams['responsibleNdx']);

			if (responsibleUserList && responsibleUserList.length) {
				setFilterValue('responsibleNdx', responsibleUserList);
			} else if(responsibleUserList1 && responsibleUserList1.length) {
				setFilterValue('responsibleNdx', responsibleUserList1);
			}

			var valueStreamNdxsList = qParamToList(qParams['valueStreamNdx']);
			setFilterValue('valueStreamNdx', valueStreamNdxsList);

			var workCenterNdxsList = qParamToList(qParams['workCenterNdx']);
			setFilterValue('workCenterNdx', workCenterNdxsList);

			var excessType = qParamToList(qParams['excessType']);
			setFilterValue('excessType', excessType);

			var valueStreamsList = qParamToList(qParams['valueStream']);
			setFilterValue('valueStream', valueStreamsList);

			var outsideLeadTimeOnly = qParamToList(qParams['outsideLeadTimeOnly']);
			for (i = 0; i < outsideLeadTimeOnly.length; i++) {
				outsideLeadTimeOnly[i] = outsideLeadTimeOnly[i] === 'true';
			}
			setFilterValue('outsideLeadTimeOnly', outsideLeadTimeOnly);

			var allFactories = qParamToList(qParams['site']);
			setFilterValue('allFactory', allFactories);

			var inventoryActionTypes = qParamToList(qParams['inventoryActionType']);
			setFilterValue('inventoryActionType', inventoryActionTypes);

			var inventoryActionStatus = qParamToList(qParams['inventoryActionStatus']);
			setFilterValue('inventoryActionStatus', inventoryActionStatus);

			var location = qParamToList(qParams['location']);
			setFilterValue('location', location);

			var order = qParamToList(qParams['order']);
			setFilterValue('order', order);

			var shortageLocation = qParamToList(qParams['locationWithShortage']);
			setFilterValue('locationWithShortage', shortageLocation);

			var orderNumberWithShortage = qParamToList(qParams['orderNumberWithShortage']);
			setFilterValue('orderNumberWithShortage', orderNumberWithShortage);

			var itemType = qParamToList(qParams['itemType']);
			setFilterValue('itemType', itemType);

			var shortageCriticalityLevel = qParamToList(qParams['shortageCriticalityLevel']);
			setFilterValue('shortageCriticalityLevelId', shortageCriticalityLevel);

			var documentType = qParamToList(qParams['documentType']);
			var notDocumentType = qParamToList(qParams['notDocumentType']);
			setFilterValue('documentType',
				documentType && documentType.length > 0 ? documentType : undefined,
				notDocumentType && notDocumentType.length > 0 ? notDocumentType : undefined);

			var lateDeliveryCategories = qParamToList(qParams['lateDeliveryCategory']);
			setFilterValue('lateDeliveryCategory', lateDeliveryCategories);

			var lateDeliveryDescriptions = qParamToList(qParams['lateDeliveryDescription']);
			setFilterValue('lateDeliveryDescription', lateDeliveryDescriptions);

			var lateDeliveryCategoryLiability = qParamToList(qParams['lateDeliveryLiability']);
			setFilterValue('lateDeliveryLiability', lateDeliveryCategoryLiability);

			var poAction = qParamToList(qParams['poAction']);
			setFilterValue('poAction', poAction);

			var bucketType = qParamToList(qParams['bucketType']);
			setFilterValue('bucketType', bucketType);

			var viewByCustomerOrEntityOrSiteList = qParamToList(qParams['viewByCustomerOrEntityOrSite']);
			setFilterValue('viewByCustomerOrEntityOrSite', viewByCustomerOrEntityOrSiteList);

			var customerSuccessOwnerIdList = qParamToList(qParams['customerSuccessOwnerId']);
			setFilterValue('customerSuccessOwnerId', customerSuccessOwnerIdList);

			setFilterValue('alert', qParamToList(qParams['alert']));

			setFilterValue('insideLeadTime', qParamToList(qParams['insideLeadTime']));

			setFilterValue('reportingPeriod', qParamToList(qParams['reportingPeriod']));
			setFilterValue('isBlanketOrder', qParamToList(qParams['isBlanketOrder']));
			setFilterValue('excludeNonQuantitySupply', qParamToList(qParams['excludeNonQuantitySupply']));
			setFilterValue('excludeNonValueSupply', qParamToList(qParams['excludeNonValueSupply']));

			// unreadChat filter and sort
			if (qParams['unreadChat']) {
				setFilterValue('chatHasUnreadMessage', [1]);
				setFilterValue('factory', Object.values(globalConfig.user.authFacts)
						.filter(function(s) { return s.customerNdx == globalConfig.customer.id; })
						.map(function(s) { return s.ndx; }));

				qParams['sort'] = 'poIdentifier';
				qParams['sortDesc'] = 1;
			};
			setFilterValue('chatWatchedByCurrentUser', qParamToList(qParams['chatWatchedByCurrentUser']));

			setFilterValue('isBlanketOrder', qParamToList(qParams['isBlanketOrder']));
			setFilterValue('isMoveInForRequirement', qParamToList(qParams['isMoveInForRequirement']));
			setFilterValue('aggregateRiskScoreLabel', qParamToList(qParams['aggregateRiskScoreLabel']));
			// range and date filters
			var creationDateValueOne = qParams['creationDateValueOne'];
			var creationDateValueTwo = qParams['creationDateValueTwo'];
			var creationDateComparator = qParams['creationDateComparator'];
			setDateFilterValue('dateCreated', creationDateValueOne,
				creationDateValueTwo, creationDateComparator);
			setDateFilterValue('actionDateCreated', creationDateValueOne,
				creationDateValueTwo, creationDateComparator);

			var orderCreationDateValueOne = qParams['orderCreationDateValueOne'];
			var orderCreationDateValueTwo = qParams['orderCreationDateValueTwo'];
			var orderCreationDateComparator = qParams['orderCreationDateComparator'];
			setRangeFilterValue('orderCreationDate', orderCreationDateValueOne,
				orderCreationDateValueTwo, orderCreationDateComparator);

			var dueDateValueOne = qParams['dueDateValueOne'];
			var dueDateValueTwo = qParams['dueDateValueTwo'];
			var dueDateComparator = qParams['dueDateComparator'];
			setDateFilterValue('dueDate', dueDateValueOne,
				dueDateValueTwo, dueDateComparator);

			var completedDateValueOne = qParams['completedDateValueOne'];
			var completedDateValueTwo = qParams['completedDateValueTwo'];
			var completedDateComparator = qParams['completedDateComparator'];
			setDateFilterValue('dateCompleted', completedDateValueOne,
				completedDateValueTwo, completedDateComparator);

			var requirementDateValueOne = qParams['requirementDateValueOne'];
			var requirementDateValueTwo = qParams['requirementDateValueTwo'];
			var requirementDateComparator = qParams['requirementDateComparator'];
			setDateFilterValue('requirementDate', requirementDateValueOne,
				requirementDateValueTwo, requirementDateComparator);

			var orderCreationDateValueOne = qParams['orderCreationDateValueOneValueOne'];
			var orderCreationDateValueTwo = qParams['orderCreationDateValueOneValueTwo'];
			var orderCreationDateComparator = qParams['orderCreationDateValueOneComparator'];
			setDateFilterValue('orderCreationDate', orderCreationDateValueOne,
				orderCreationDateValueTwo, orderCreationDateComparator);

			var onOrderValueOne = qParams['onOrderValueOne'];
			var onOrderValueTwo = qParams['onOrderValueTwo'];
			var onOrderComparator = qParams['onOrderComparator'];
			setRangeFilterValue('remainingQuantityFloat', onOrderValueOne, onOrderValueTwo,
				onOrderComparator);

			var daysUntilPoValueOne = qParams['daysUntilPoValueOne'];
			var daysUntilPoValueTwo = qParams['daysUntilPoValueTwo'];
			var daysUntilPoValueComparator = qParams['daysUntilPoComparator'];
			setRangeFilterValue('daysUntilPOFirm', daysUntilPoValueOne, daysUntilPoValueTwo,
				daysUntilPoValueComparator);

			var daysUntilPLTValueOne = qParams['daysUntilPLTValueOne'];
			var daysUntilPLTValueTwo = qParams['daysUntilPLTValueTwo'];
			var daysUntilPPLTValueComparator = qParams['daysUntilPLTComparator'];
			setRangeFilterValue('daysUntilProcurementLeadTime', daysUntilPLTValueOne, daysUntilPLTValueTwo,
				daysUntilPPLTValueComparator);

			var daysInShortageValueOne = qParams['daysInShortageValueOne'];
			var daysInShortageValueTwo = qParams['daysInShortageValueTwo'];
			var daysInShortageComparator = qParams['daysInShortageComparator'];
			setRangeFilterValue('daysInShortage', daysInShortageValueOne, daysInShortageValueTwo,
				daysInShortageComparator);

			var aggregateRiskScoreValueOne = qParams['aggregateRiskScoreValueOne'];
			var aggregateRiskScoreValueTwo = qParams['aggregateRiskScoreValueTwo'];
			var aggregateRiskScoreComparator = qParams['aggregateRiskScoreComparator'];
			setRangeFilterValue('aggregateRiskScore', aggregateRiskScoreValueOne, aggregateRiskScoreValueTwo,
				aggregateRiskScoreComparator);

			var timePeriod = qParams['timePeriod'];
			var timePeriodValueOne = qParams['timePeriodValueOne'];
			var timePeriodValueTwo = qParams['timePeriodValueTwo'];
			var timePeriodValueComparator = qParams['timePeriodValueComparator'];
			setRangeFilterValue('timePeriod', timePeriodValueOne, timePeriodValueTwo, timePeriodValueComparator,
				timePeriod);

			var spendTimePeriod = qParams['spendTimePeriod'];
			var spendTimePeriodValueOne = qParams['spendTimePeriodValueOne'];
			var spendTimePeriodValueTwo = qParams['spendTimePeriodValueTwo'];
			var spendTimePeriodValueComparator = qParams['spendTimePeriodValueComparator'];
			setRangeFilterValue('spendTimePeriod', spendTimePeriodValueOne, spendTimePeriodValueTwo, spendTimePeriodValueComparator,
				spendTimePeriod);

			var onOrderPlannedValueOne = qParams['onOrderPlannedValueOne'];
			var onOrderPlannedValueTwo = qParams['onOrderPlannedValueTwo'];
			var onOrderPlannedComparator = qParams['onOrderPlannedComparator'];
			setRangeFilterValue('plannedOnOrderQuantity', onOrderPlannedValueOne, onOrderPlannedValueTwo,
				onOrderPlannedComparator);

			var onOrderFirmedValueOne = qParams['onOrderFirmedValueOne'];
			var onOrderFirmedValueTwo = qParams['onOrderFirmedValueTwo'];
			var onOrderFirmedComparator = qParams['onOrderFirmedComparator'];
			setRangeFilterValue('firmedOnOrderQuantity', onOrderFirmedValueOne, onOrderFirmedValueTwo,
				onOrderFirmedComparator);

			var requestedDateValueOne = qParams['requestedDateValueOne'];
			var requestedDateValueTwo = qParams['requestedDateValueTwo'];
			var requestedDateComparator = qParams['requestedDateComparator'];
			setRangeFilterValue('goldenSupplyDate', requestedDateValueOne,
				requestedDateValueTwo, requestedDateComparator);

			var prHistoryDateValueOne = qParams['prHistoryDateValueOne'];
			var prHistoryDateValueTwo = qParams['prHistoryDateValueTwo'];
			var prHistoryDateComparator = qParams['prHistoryDateComparator'];
			setRangeFilterValue('prHistoryDate', prHistoryDateValueOne,
				prHistoryDateValueTwo, prHistoryDateComparator);

			var myItemOnlyValue = qParams['myItemOnly'];
			setMyItemFilterValue('myItemsOnly', decodeURIComponent(myItemOnlyValue));

			var filterParamString = qParams.filter;
			if (filterParamString) {
				filterParamString = decodeURIComponent(filterParamString);
				var filterParams = getFilterQueryParamValues(filterParamString);
				if (filterParams && filterParams.length) {
					filterParams.forEach(function (filterParam) {
						var filterValue = filterParam.value;
						switch (filterParam.type) {
						case 'numeric':
						case 'date': {
							var existingFilterParams = filterParams.filter(function (param) {
								return param.field === filterParam.field;
							});
							if (existingFilterParams.length === 1) {
								setRangeFilterValue(filterParam.field, filterValue, null, filterParam.comparison);
							} else if (existingFilterParams.length === 2) {
								var lowerDateParam = existingFilterParams[0].comparison === 'gte' ? existingFilterParams[0] : existingFilterParams[1];
								var greaterDateParam = existingFilterParams[0].comparison === 'gte' ? existingFilterParams[1] : existingFilterParams[0];
								setRangeFilterValue(filterParam.field, lowerDateParam.value, greaterDateParam.value, 'btw');
							}
							break;
						}
						case 'string':
							setStringFilterValue(filterParam.field, filterValue);
							break;
						default: {
							if (typeof filterValue === 'string') {
								if (filterValue.includes(',')) {
									filterValue = filterValue.split(',');
								} else {
									filterValue = [filterValue];
								}
							}
							setFilterValue(filterParam.field, filterValue);
							break;
						}
						}
					});
				}
			}

			var isSupplierPortal = globalConfig.user.role === 'Supplier';

			if (!isSupplierPortal) {
				var supplierNdxList = qParamToList(qParams['supplierNdx']);
				// convert supplierNdx's from strings to integers
				for (i = 0; i < supplierNdxList.length; i++) {
					supplierNdxList[i] = isNaN(supplierNdxList[i]) ? supplierNdxList[i] : Number(supplierNdxList[i]);
				}
				var supplierCodeList = qParamToList(qParams['supplierCode']);
				var notSupplierCodeList = qParamToList(qParams['notSupplierCode']);
				var notSupplierNdxList = qParamToList(qParams['notSupplierNdx']);
				if (supplierNdxList && supplierNdxList.length > 0) {
					setFilterValue('supplierNdx', supplierNdxList, undefined);
				} else if (supplierCodeList && supplierCodeList.length > 0) {
					setFilterValue('supplierNdx', supplierCodeList, undefined);
				} else if (notSupplierCodeList && notSupplierCodeList.length > 0) {
					setFilterValue('supplierNdx', undefined, notSupplierCodeList);
				} else if (notSupplierNdxList && notSupplierNdxList.length > 0) {
					setFilterValue('supplierNdx', undefined, notSupplierNdxList);
				}
			}

			//START ONE OFF qPARAMS
			if (!paramSettings.filters) paramSettings.filters = [];

			//Not Purchase Requisition
			var excludePurchaseReqs = !qParams || qParams['excludePurchaseReqs'];
			var filterId, curList, newFilterList, i;
			if (qParams && excludePurchaseReqs) {
				filterId = 'purchaseDocumentType';
				setFilterValue(filterId, undefined, ['Purchase Requisition']);
			}

			// Not purchase document types
			var excludeDocumentTypes = !qParams || qParams['excludePurchaseDocumentTypes'];
			if (qParams && excludeDocumentTypes && excludeDocumentTypes.length) {
				var excludeList = decodeURIComponent(excludeDocumentTypes).split(',');
				filterId = 'purchaseDocumentType';
				setFilterValue(filterId, undefined, excludeList);
			}

			//Not MinMax
			var excludeMinMax = !qParams || qParams['excludeMinMax'];
			if (qParams && excludeMinMax) {
				filterId = 'erpOrderPolicy';
				curList = leanFilterService.getList(filterId);
				newFilterList = [];
				for (i = 0; i < curList.length; i++) {
					if (curList[i].orderPolicy !== 'MinMax') {
						newFilterList.push(curList[i][filterId]);
					}
				}
				setFilterValue(filterId, newFilterList);
			}

			var minMaxOnly = !qParams || qParams['minMaxOnly'];
			if (qParams && minMaxOnly) {
				filterId = 'erpOrderPolicy';
				newFilterList = [];
				curList = $scope.filterService.getList(filterId);
				for (i = 0; i < curList.length; i++) {
					if (curList[i].orderPolicy === 'MinMax') {
						newFilterList.push(curList[i][filterId]);
					}
				}
				setFilterValue(filterId, newFilterList);
			}

			if (qParams && qParams['forCurUser']) {
				var responsibleNdxList = [globalConfig.user.id];
				setFilterValue('responsibleNdx', responsibleNdxList);
			}

			// this will allow filters.js to disable "show archived" for drilldowns
			paramSettings.defaultConfig = true;

			if (extraFilters && extraFilters.length) {
				for (var i = 0; i < extraFilters.length; i++) {
					var filtConf = extraFilters[i];
					if (filtConf && filtConf.type == 'range') {
						var valueOneKey = filtConf.valueOne;
						var valueTwoKey = filtConf.valueTwo;
						var valOne = !qParams || qParams[valueOneKey];
						var valTwo = !qParams || qParams[valueTwoKey];

						var type = leanFilterService.getTypeOfFilter(filtConf.name);
						if (type == 'numerical') {
							if (valOne)
								valOne = parseInt(valOne);
							if (valTwo)
								valTwo = parseInt(valTwo);
						}
						if (qParams && (valOne || valOne == 0)) {
							var index = findInArray(paramSettings.filters, 'id', filtConf.name);
							if (index >= 0) {
								paramSettings.filters[index].comparator = filtConf.comparator;
								paramSettings.filters[index].valueOne = valOne;
								paramSettings.filters[index].valueTwo = valTwo;
							} else {
								paramSettings.filters.push({
									'id': filtConf.name,
									'comparator': filtConf.comparator,
									'valueOne': valOne,
									'valueTwo': valTwo
								});
							}
						}
					}
				}
			}
			var searchTerm = !qParams || qParams['search'];
			if (qParams && searchTerm && searchTerm != '') {
				paramSettings.search = decodeURIComponent(searchTerm);
				leanFilterService.setSearchBoxDataValue(paramSettings.search);
			}
			// Handle sort query param
			paramSettings.sorters = [];
			var sort = !qParams || qParams['sort'];
			if (qParams && sort && sort != '') {
				var isDesc = qParams['sortDesc'] == 1;
				paramSettings.sorters = [];
				paramSettings.sorters.push({
					'direction': isDesc ? 'DESC' : 'ASC',
					'property': sort
				});
			}
			var mandatoryColumnList = qParamToList(qParams['mandatoryColumns']);
			paramSettings.mandatoryColumns = mandatoryColumnList;
			return paramSettings;
		}

		function getChatStatus(chat) {
			var chatStatus = 'nochat';
			var internalRead;
			var externalRead;

			if (globalConfig.user.role !== 'Supplier' && chat && chat['internal'] && chat['internal']['topicName']) {
				internalRead = chat['internal']['isRead'];
			}

			if (chat && chat['external'] && chat['external']['topicName']) {
				externalRead = chat['external']['isRead'];
			}

			if(!chat || !chat.lastActivity) {
				chatStatus = 'nochat';
			} else {
				if (externalRead !== undefined) {
					if (internalRead !== undefined) {
						chatStatus = externalRead && internalRead ? 'read' : 'unread';
					} else {
						if (externalRead) {
							chatStatus = 'read';
						}	else {
							chatStatus = 'unread';
						}
					}
				}
			}

			return chatStatus;
		}
	}
})();
